import { usePermissao } from "@/utils/permissao";
import { EntityIcon } from "@/components/ui/cores";
import { PageHeader } from "@/components/ui/page-header";
import { Column, DataTable, Pagination } from "@/components/datatable/DataTable";
import { ExportarButton, TODOS_REGISTROS } from "@/components/datatable/ExportarButton";
import Filter from "@/components/datatable/Filter";
import { ActionButton, Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { SeguradoraService } from "@/services";
import { PageRequest, PaginationData } from "@/types/pagination";
import { Pencil, Plus, Eye } from "lucide-react";
import { useRef, useState } from "react";
import { Seguradora } from "@/types/SeguradoraDTO";
import { useNavigate } from "react-router-dom";
import { Sort } from "@/types/sort";
import { AxiosError } from "axios";
import { ErrorPage } from "../ErrorPage";

type SeguradoraListProps = {
    
}

export const SeguradoraListPage = (props: SeguradoraListProps) => {
  const [data, setData] = useState<Seguradora[]>([]);
  const [pagination, setPagination] = useState<PaginationData>();
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<AxiosError>();
  const navigate = useNavigate();
  const podeAlterar = usePermissao('SEGURADORA_WRITE');

  const ultimaBusca = useRef<[string?, PageRequest?, Sort?]>([]);

  const columns: Column[] = [
    {field: 'id', show: false, label: 'ID'},
    {field: 'nome', show: true, label: 'Nome', filter: true, sorted: true} 
  ]

  const onSearch = (filterRsql?: string, pagination?: PageRequest, sort?: Sort) => {
    ultimaBusca.current = [filterRsql, pagination, sort];
    setLoading(true);
    SeguradoraService.findSeguradoras(filterRsql, pagination, sort)
      .then(response => {
        setData(response.data.content)
        setPagination({
          ...response.data
        })
      })
      .catch(setError)
      .finally(() => setLoading(false));
  }

  if (error){
    return <ErrorPage axiosError={error} />
  }

  return (
    <div className="space-y-4">
    <PageHeader icon={<EntityIcon entidade="seguradora" />} title="Seguradoras" total={pagination?.totalElements}>
      <ExportarButton arquivo="seguradoras" columns={columns} buscar={() => SeguradoraService.findSeguradoras(ultimaBusca.current[0], TODOS_REGISTROS, ultimaBusca.current[2])} />
      {podeAlterar && <Button onClick={() => navigate('novo')}><Plus className="mr-2 h-4 w-4" /> Nova seguradora</Button>}
    </PageHeader>
    <Card className="overflow-hidden shadow-none">
      <Filter columns={columns} onSearch={onSearch} defaultSort={{sort: "nome,asc"}} loading={loading}/>
      <DataTable values={data} loading={loading}
        columns={columns} 
        keyExtractor={(item: any, index: number) => item.id} 
        pagination={pagination}
        actions={(item: any) => {
          return (
            <>
            <ActionButton onClick={() => navigate(item.id)} icon={podeAlterar ? <Pencil className="h-3.5 w-3.5" /> : <Eye className="h-3.5 w-3.5" />} label={podeAlterar ? "Editar" : "Visualizar"} />            
            </>
          )
        }}
      />
      <Pagination pagination={pagination} />
    </Card>
    </div>
  )
}